import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ShareLink } from '../ShareLink';
import { ShareQR } from '../ShareQR';

import * as S from './style';

export const SharePublicLink = ({ secureSingleLink, featureType }) => {
  const { t } = useTranslation();

  return (
    <S.SharePublicLink>
      <S.SharePublicLinkLeft>
        <Typography variant="body1Bold">{t('giftLink')}</Typography>
        <ShareLink
          position="left-start"
          secureSingleLink={secureSingleLink}
          featureType={featureType}
        />
      </S.SharePublicLinkLeft>
      <ShareQR size={72} link={secureSingleLink} />
    </S.SharePublicLink>
  );
};
